import { render, staticRenderFns } from "./CandidateStaticContentsTable.vue?vue&type=template&id=4ff98f19&"
import script from "./CandidateStaticContentsTable.vue?vue&type=script&lang=js&"
export * from "./CandidateStaticContentsTable.vue?vue&type=script&lang=js&"
import style0 from "./CandidateStaticContentsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports